var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tournaments"},[_c('profile-tournaments',{attrs:{"hash":_vm.hash,"show-subtitle":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }